import React from 'react';

const PaginationControls = ({ 
  pagination, 
  currentPage, 
  onPageChange, 
  onPreviousPage, 
  onNextPage,
  className = "",
  showInfo = true 
}) => {
  if (!pagination) {
    return (
      <div className={`alert alert-warning ${className}`}>
        No pagination data received
      </div>
    );
  }

  return (
    <div className={className}>
      <div className="d-flex justify-content-between align-items-center">
        {showInfo && (
          <div>
            <span className="text-muted">
              Showing {((pagination.current_page - 1) * pagination.page_size) + 1} to {Math.min(pagination.current_page * pagination.page_size, pagination.total_count)} of total {pagination.total_count} entries
            </span>
          </div>
        )}
        <nav aria-label="Pagination">
          <ul className="pagination mb-0">
            <li className={`page-item ${!pagination.has_previous ? 'disabled' : ''}`}>
              <button
                className="page-link"
                onClick={() => onPreviousPage ? onPreviousPage() : onPageChange(pagination.current_page - 1)}
                disabled={!pagination.has_previous}
              >
                Previous
              </button>
            </li>
            
            {/* Page numbers */}
            {Array.from({ length: Math.min(5, pagination.total_pages) }, (_, i) => {
              let pageNum;
              if (pagination.total_pages <= 5) {
                pageNum = i + 1;
              } else if (pagination.current_page <= 3) {
                pageNum = i + 1;
              } else if (pagination.current_page >= pagination.total_pages - 2) {
                pageNum = pagination.total_pages - 4 + i;
              } else {
                pageNum = pagination.current_page - 2 + i;
              }
              
              return (
                <li key={pageNum} className={`page-item ${pagination.current_page === pageNum ? 'active' : ''}`}>
                  <button
                    className="page-link"
                    onClick={() => onPageChange(pageNum)}
                  >
                    {pageNum}
                  </button>
                </li>
              );
            })}
            
            <li className={`page-item ${!pagination.has_next ? 'disabled' : ''}`}>
              <button
                className="page-link"
                onClick={() => onNextPage ? onNextPage() : onPageChange(pagination.current_page + 1)}
                disabled={!pagination.has_next}
              >
                Next
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default PaginationControls;